import { Box, Theme, Typography } from "@mui/material";
import PrudentialNormsTable from "./tables/prudentialNormsTable";
import MaxAllocationMFTable from "./tables/maxAllocationMFTable";

export default function PortfolioPrudentialNorms({
    clientCode,
    portfolioId
}: {
    clientCode: string;
    portfolioId: string;
}): JSX.Element {
    return (
        <>
            <PrudentialNormsTable />
            <Box sx={{ borderBottom: '0.5px dashed black', mt: '40px' }} />
            <Box
                sx={(theme: Theme) => ({
                    borderRadius: "25px",
                    padding: "35px",
                    backgroundColor: theme.palette.common.white,
                    boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                    mt: '25px',
                    border: `0.5px solid ${theme.palette.grey[50]}`
                })}
            >
                <Typography variant="body_600" sx={{ lineHeight: '25px', letterSpacing: '0.01px' }}>
                    {/* Max Allocation to Mutual Funds/Managed Accounts */}
                    Portfolio Compliance
                </Typography>
                <MaxAllocationMFTable
                    clientCode={clientCode}
                    portfolioId={portfolioId}
                />
            </Box>
        </>
    )
}